import * as React from 'react'

import { Box, SearchField, Table } from '@factorialco/deprecated-design-system'

import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import type { AuthorsMap } from 'modules/surveys/pages/settings/SettingsPage'
import type QuestionsTemplate from 'modules/surveys/store/models/QuestionsTemplate'

import Body from './Body'

interface Props {
  questionsTemplatesList: QuestionsTemplate[]
  authorsMap: AuthorsMap
}

export default function QuestionsTemplatesTable({ questionsTemplatesList, authorsMap }: Props) {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const TableOptions = () => (
    <Box flexGrow>
      <SearchField
        variant="big"
        search={search}
        onSearch={onSearch}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )

  return (
    <Table options={TableOptions}>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell colSpan={3} ellipsis>
            {i18n.t('common.name')}
          </Table.HeadCell>
          <Table.HeadCell colSpan={2}>{i18n.t('common.author')}</Table.HeadCell>
          <Table.HeadCell colSpan={1}>
            {i18n.t('app_store_v2.apps.performance_v2.settings.templates.table.questions')}
          </Table.HeadCell>
          <Table.HeadCell />
        </Table.Row>
      </Table.Head>
      <Table.Body>
        <Body
          search={debouncedSearch}
          questionsTemplatesList={questionsTemplatesList}
          authorsMap={authorsMap}
        />
      </Table.Body>
    </Table>
  )
}
